import React, { Component, useState } from "react";
import { useHistory } from "react-router-dom";
import { Slider, Slide, ButtonBack, ButtonNext, WithStore } from "pure-react-carousel";
import LazyLoad from "react-lazyload";
import { getUrl } from "@outplayed/riot-assets";

const colorMap = {
  Hard: "#ff9b00",
  Medium: "#08a6ff",
  Easy: "#7ed321",
  Smurf: "#ff4e50",
};

const PlaceholderComponent = (props) => {
  return <img className="combo-placeholder" src={getUrl("lol/combos/imgs/combo-placeholder.svg")}></img>;
};

const ComboLink = (props) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const { data, champ } = props;
  const history = useHistory();
  const goCombo = (e) => {
    if (history && data.id && champ) {
      let champPath = champ;
      if (champ == "monkeyking") {
        champPath = "wukong";
      }
      history.push(`/lol/champions/${champPath}/combo/${data.id}`);
    }
  };

  const thumbLink = `https://i.vimeocdn.com/video/${data.vimeo_pic_id}_169x95.jpg`;
  return (
    <div>
      <LazyLoad height={196} placeholder={<PlaceholderComponent />}>
        <div className="combo-container" onClick={goCombo}>
          <img
            className="combo-thumb"
            src={thumbLink}
            alt="thumb"
            onLoad={() => {
              setImgLoaded(true);
            }}
          />
          {imgLoaded && (
            <div>
              <div className="title">{data.name}</div>
              <div className="rating" style={{ color: `${colorMap[data.difficulty]}` }}>
                {data.difficulty.toUpperCase()}

                {props.index !== 0 && (
                  <img
                    style={{ width: "12px", height: "12px", margin: "0px 0px 5px 10px" }}
                    src={getUrl("lol/combos/imgs/lock-icon.png")}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </LazyLoad>
      {!imgLoaded && <PlaceholderComponent />}
    </div>
  );
};

//this is a component because of the carousel lib.
class ComboSlider extends Component {
  render() {
    const { data } = this.props;
    return (
      <div>
        <div style={{ position: "relative", top: 60 }}>
          <ButtonBack>
            {this.props.currentSlide >= this.props.totalSlides % this.props.visibleSlides ? (
              <img
                className="btn-img"
                src="https://static.bigbrain.gg/assets/lol/combos/imgs/arrow-left-white.svg"
                alt="back-btn"
              />
            ) : (
              <img
                className="btn-img"
                src="https://static.bigbrain.gg/assets/lol/combos/imgs/arrow-left-grey.svg"
                alt="back-btn"
              />
            )}
          </ButtonBack>
        </div>
        <div style={{ marginLeft: 60, width: 895, height: 197 }}>
          <Slider>
            {data.combos.map((combo, index) => {
              return (
                <Slide index={index} key={index}>
                  <ComboLink data={combo} champ={data.id} key={index} index={index} />
                </Slide>
              );
            })}
          </Slider>
        </div>
        <div style={{ position: "relative", top: -164, left: 973, width: 40 }}>
          <ButtonNext>
            {this.props.currentSlide < this.props.totalSlides % this.props.visibleSlides ? (
              <img
                className="btn-img"
                src="https://static.bigbrain.gg/assets/lol/combos/imgs/arrow-right-white.svg"
                alt="back-btn"
              />
            ) : (
              <img
                className="btn-img"
                src="https://static.bigbrain.gg/assets/lol/combos/imgs/arrow-right-grey.svg"
                alt="back-btn"
              />
            )}
          </ButtonNext>
        </div>
      </div>
    );
  }
}

export default WithStore(ComboSlider, (state) => ({
  // these are read only properties.  we use the "deepFreeze"
  // npm package to make these properties immutable. You don't have to use
  // all of these, just pick the ones you need.
  currentSlide: state.currentSlide,
  disableAnimation: state.disableAnimation,
  hasMasterSpinner: state.hasMasterSpinner,
  imageErrorCount: state.imageErrorCount,
  imageSuccessCount: state.imageSuccessCount,
  lockOnWindowScroll: state.lockOnWindowScroll,
  masterSpinnerThreshold: state.masterSpinnerThreshold,
  naturalSlideHeight: state.naturalSlideHeight,
  naturalSlideWidth: state.naturalSlideWidth,
  orientation: state.orientation,
  slideSize: state.slideSize,
  slideTraySize: state.slideTraySize,
  step: state.step,
  dragStep: state.dragStep,
  totalSlides: state.totalSlides,
  touchEnabled: state.touchEnabled,
  dragEnabled: state.dragEnabled,
  visibleSlides: state.visibleSlides,
}));
